export interface AboutContent {
  brandIntro: {
    title: string;
    paragraphs: string[];
    mission: string;
    vision: string;
  };
  reputation: {
    title: string;
    stats: { value: string; label: string }[];
    testimonials: { quote: string; author: string; role: string }[];
    achievements: string[];
  };
  contact: {
    title: string;
    email: string;
    address: string;
    workingHours: string;
    wechat: string;
  };
}

export const aboutContent: AboutContent = {
  brandIntro: {
    title: '品牌介绍',
    paragraphs: [
      '韩国伦理文化研究（Korea Ethics Culture Research）创立于2018年，是专注于韩国伦理文化深度解析的中文内容平台。我们致力于为华语世界的读者提供专业、全面、深入的韩国伦理文化知识，搭建中韩文化交流的桥梁。',
      '我们的团队由韩国学研究学者、文化评论人和资深媒体人组成，每位成员都拥有丰富的韩国文化研究经验和深厚的学术背景。我们坚信，理解一个国家的伦理文化，是真正理解这个国家的最佳入口。',
      '自成立以来，我们已经发布了超过200篇原创深度文章，涵盖儒家伦理传统、现代伦理观念、家庭伦理、职场伦理、影视文化中的伦理等多个维度。我们的内容被多家知名媒体和学术机构引用，在华语韩国文化研究领域享有良好的学术声誉。',
    ],
    mission: '通过严谨的学术研究和生动的文化叙事，帮助华语读者深入理解韩国伦理文化的精髓，促进东亚文化圈内的相互理解和尊重。',
    vision: '成为华语世界最具权威性和影响力的韩国伦理文化研究与传播平台，推动东亚伦理文化的比较研究与对话交流。',
  },
  reputation: {
    title: '品牌声誉',
    stats: [
      { value: '200+', label: '原创深度文章' },
      { value: '50万+', label: '月均读者' },
      { value: '30+', label: '合作学术机构' },
      { value: '98%', label: '读者满意度' },
    ],
    testimonials: [
      {
        quote: '韩国伦理文化研究是我了解韩国文化最重要的中文资源。文章既有学术深度，又通俗易懂，让我对韩国社会有了全新的理解。',
        author: '王教授',
        role: '北京大学韩国学研究中心',
      },
      {
        quote: '作为在韩国工作的中国人，这个平台帮助我更好地理解和适应了韩国的职场文化和社会规范。每一篇文章都值得反复阅读。',
        author: '张先生',
        role: '三星电子中国区经理',
      },
      {
        quote: '在研究韩国家庭伦理变迁的过程中，这个平台提供的系统化分析和翔实案例给了我极大的学术启发。',
        author: '李博士',
        role: '中国社会科学院',
      },
    ],
    achievements: [
      '荣获"2023年度最佳文化类内容平台"奖项',
      '与韩国文化振兴院（KOCCA）建立官方合作关系',
      '出版《韩国伦理文化十讲》系列电子书，下载量突破10万',
      '受邀在TEDx、一席等平台进行韩国文化主题演讲',
      '被多所高校列为韩国文化课程推荐阅读资源',
      '连续三年入选"中文互联网最具影响力韩国文化媒体TOP10"',
    ],
  },
  contact: {
    title: '联系我们',
    email: 'contact@korea-ethics.com',
    address: '韩国首尔特别市钟路区世宗大路175号',
    workingHours: '周一至周五 09:00 - 18:00（韩国标准时间）',
    wechat: 'korea_ethics_culture',
  },
};